import { createContext, useContext } from "react";
import type { ResolvedAppearance } from "@/lib/theme/boot";
import type { Theme } from "@/lib/theme/type";

/**
 * `theme` is already the resolved one — in the dark appearance it is the brand's derived night, not
 * its light theme. `appearance` is alongside it for the rare component that has to branch rather
 * than take a colour: an illustration with baked-in shadows, a map style, a third-party widget.
 *
 * `brandTheme` is what the organization actually configured, always light. Only the appearance
 * picker needs it, to show what the other option would look like without switching into it first.
 */
export const ThemeContext = createContext<{
  theme: Theme;
  brandTheme: Theme;
  appearance: ResolvedAppearance;
} | null>(null);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
